<template>
  <div class="layout">
    <section>
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getUserInfo } from '@/api/login'

export default {
  created () {
    this.getUserInfo()
  },
  computed: {
    userName: {
      get () { return this.$store.state.user.name },
      set (val) { this.$store.commit('user/updateName', val) }
    }
  },
  methods: {
    ...mapMutations('user', {
      updateMenuCodeSet: 'updateMenuCodeSet'
    }),
    // 获取当前管理员信息
    async getUserInfo () {
      const { data = {} } = await getUserInfo()
      const { userId, username, isAdmin, menuCodeSet } = data
      this.loading = false
      this.userId = userId
      this.userName = username
      localStorage.isAdmin = isAdmin
      sessionStorage.username = username
      this.updateMenuCodeSet(menuCodeSet)
    }
  }
}
</script>

<style lang="scss" scoped>
  .layout {
    height: 100vh;
    section {
      height: 100%;
    }
  }
</style>